
import { CdkStepper } from '@angular/cdk/stepper';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { recipeModel } from '../common/models/recipeDetailsModel';
import { DataService } from '../common/services/data.service';
import { WorklistService } from '../worklist/worklist.service';
import { AssessRequestRaService } from './assess-request-ra.service';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-assess-request-ra',
  templateUrl: './assess-request-ra.component.html',
  styleUrls: ['./assess-request-ra.component.scss'],
  providers: [{ provide: CdkStepper }]
})

export class AssessRequestRaComponent implements OnInit, OnDestroy {
  private readonly destroying$ = new Subject<void>();
  activeTab = 'nav-formulation-details';
  star = 'fa fa-fw fa-search';
  componentNameTab = 'AssessRequestsRA';
  loading = false;
  loadingMsg = 'Please wait User Authentication is in progress';
  public steps: string[];
  public selectedStep = 0;
  userDetails = null;
  isSuperAdmin = false;
  isRA = false;
  isRnD = false;
  isPlmRoute = false;
  requestid;
  step;

  /* istanbul ignore next */
  constructor(
    public formBuilder: FormBuilder,
    public assessRaService: AssessRequestRaService,
    private routersvc: Router,
    private route: ActivatedRoute,
    public dialogbox: MatDialog,
    public matSnackBar: MatSnackBar,
    private worklistservice: WorklistService,
    private msalSvc: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private dataSvc: DataService) {

  }
  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroying$.next();
    this.destroying$.complete();
  }
  /* istanbul ignore next */
  ngOnInit() {
    this.getUserRoleDetails();
    this.dataSvc.setComponentName(this.componentNameTab);
    this.steps = this.route.snapshot.routeConfig.children.map(child => child.path);
    this.worklistservice.getProfileObs().subscribe(profile => this.requestid = profile);
    // tslint:disable-next-line: prefer-const
    let urlId = this.routersvc.url.split('/');
    if (this.requestid === null) {
      this.requestid = urlId[urlId.length - 1];
    }
    if (this.msalSvc.instance.getAllAccounts().length === 0) {
      this.loading = true;
      this.loadingMsg = 'Please wait User Authentication is in progress';
      this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
          takeUntil(this.destroying$)
        )
        .subscribe(() => {
          this.loading = false;
          this.loadingMsg = '';
        });
    }
    const isViewReportClicked = this.dataSvc.isViewReportClicked;
    const requestStatus = this.dataSvc.requestStatusForReport;
    if (urlId[2] === 'submit-report-plm') {
      this.isPlmRoute = true;
    } else {
      this.isPlmRoute = false;
    }

    const openWorklistReport = this.route.snapshot.queryParamMap.get('openWorklistReport') === 'true';
    if (openWorklistReport) {
      const requestId = this.route.snapshot.queryParamMap.get('requestId');
      const reportKey = this.route.snapshot.queryParamMap.get('reportKey');
      const reportPayload = reportKey ? localStorage.getItem(reportKey) : null;
      if (requestId && reportKey && reportPayload) {
        this.openWorklistReport(reportPayload, reportKey, requestId);
      } else if (requestId && reportKey) {
        const receiveReport = (event: StorageEvent) => {
          if (event.key === reportKey && event.newValue) {
            window.removeEventListener('storage', receiveReport);
            this.openWorklistReport(event.newValue, reportKey, requestId);
          }
        };
        window.addEventListener('storage', receiveReport);
      }
      return;
    }

    if (urlId[2] === 'submit-report-plm') {
      this.selectedStep = 3;
      // const compltedreport = JSON.parse(localStorage.getItem('CompletedReport'));
      const division = urlId[4];
      this.step = 'submit-report-plm/' + urlId[3] + '/' + division;
      //  this.step = 'submit-report-plm/' + compltedreport.requestDisplayID;
      this.componentNameTab = 'SubmitReportPLM';
      this.dataSvc.setComponentName(this.componentNameTab);
    } else if (urlId[2] === 'verify-request-plm' && this.steps[4] === 'verify-request-plm/:requestId' && recipeModel.requestStatus !== 'In Progress – R&D') {
      this.step = 'verify-request-plm/' + this.requestid;
      this.dataSvc.setComponentName(this.componentNameTab);
    } else if (urlId[1] === 'assess-request-ra' && urlId[2] === 'execute-rules' && (recipeModel.requestStatus === 'Submitted' || ((this.isRA || this.isSuperAdmin) && (recipeModel.requestStatus === 'Assigned' || recipeModel.requestStatus === 'In Progress – RA')))) {
      this.selectedStep = 2;
      this.step = 'execute-rules';
    } else if (this.steps[0] === 'verify-request/:requestId' && recipeModel.requestStatus !== 'In Progress – R&D' && isViewReportClicked === 'false') {
      this.step = 'verify-request/' + this.requestid;
    } else if (this.steps[3] === 'submit-report' && requestStatus === 'Completed' && isViewReportClicked === 'true') {
      this.selectedStep = 3;
      this.step = 'submit-report';
      this.componentNameTab = 'SubmitReportRA';
      this.dataSvc.setComponentName(this.componentNameTab);
    } else if (recipeModel.requestStatus === 'In Progress – R&D') {
      this.selectedStep = 2;
      this.step = 'execute-rules';
    } else {
      this.step = 'verify-request/' + this.requestid;
    }
    this.steps = this.steps.slice(0, 4);
    this.routersvc.navigate([this.step], { relativeTo: this.route });
  }
  private openWorklistReport(payload: string, reportKey: string, requestId: string) {
    const report = JSON.parse(payload);
    localStorage.removeItem(reportKey);
    Object.assign(recipeModel, report);
    recipeModel.requestDisplayID = requestId;
    this.dataSvc.completedReport = report;
    this.dataSvc.isViewReportClicked = 'true';
    this.dataSvc.requestStatusForReport = 'Completed';
    this.dataSvc.setComponentName('SubmitReportRA');
    this.dataSvc.setSelectedStep(3);
    this.dataSvc.updateRequestId(report);
    this.worklistservice.setProfileObs(requestId);
    this.worklistservice.setRecipeData({
      requestID: requestId,
      requestStatus: report.requestStatus
    });
    this.worklistservice.setRequestStatus(report.requestStatus);
    this.selectedStep = 3;
    this.routersvc.navigate(['submit-report'], { relativeTo: this.route });
  }
  /* istanbul ignore next */
  selectionChanged(event: any) {
    if (this.isPlmRoute || this.routersvc.url.indexOf('submit-report-plm') !== -1) {
      return;
    }
    this.selectedStep = event.selectedIndex;
    this.worklistservice.getProfileObs().subscribe(profile => this.requestid = profile);
    if (event.selectedIndex === 0) {
      this.step = 'verify-request/' + this.requestid;
      this.routersvc.navigate([this.step], { relativeTo: this.route });
    } else {
      this.routersvc.navigate([this.steps[this.selectedStep]], { relativeTo: this.route });
    }
  }
  getUserRoleDetails() {
    const stored = localStorage.getItem('userRolesPermissions');
    if (!stored) {
      return;
    }
    this.userDetails = JSON.parse(stored);
    if (this.userDetails.roles !== undefined && this.userDetails.roles !== null && this.userDetails.roles.length > 0) {
      this.userDetails.roles.forEach(c => {
        if (c.roleId === 150) {
          this.isSuperAdmin = true;
        }
        if (c.roleId === 140 || c.roleId === 130 || c.roleId === 160 || c.roleId === 170) {
          this.isRA = true;
        }
        if (c.roleId === 120 || c.roleId === 110 || c.roleId === 170) {
          this.isRnD = true;
        }
      });
    }
  }

}
